<template>
	<div>
	<participant-filter-2
		@submit="getParticipants"
		:loading="myloading"
	>
	</participant-filter-2>
	<v-btn
		class="buttons"
		@click="excelExport"
	>
		{{ txt.btn.excelExport }}
	</v-btn>
	<br/> <br/>
	<v-data-table
		id="dataTable"
		:headers="participantheader"
		:items="participantData"
		:loading="myloading"
		loading-text="Loading, please wait..."
	/>
	</div>
</template>

<script>
import axios from 'axios'
import ParticipantFilter2 from './ParticipantFilter2.vue'

export default {
	components: { ParticipantFilter2 },
	data() {
		return {
			txt: {
				btn: {
					excelExport: 'Participant list excel export',
				},
			},
			myloading: false,
			singleSelect: true,
			expanded: [],
			participantheader: [
				{
					value: 'order_state',
					text: 'Order state',
					class: 'white--text',
				},
				{
					value: 'address',
					text: 'Address',
					class: 'white--text',
				},
				{
					value: 'phoneNumber',
					text: 'Phone Number',
					class: 'white--text',
				},
				{
					value: 'email',
					text: 'Email',
					class: 'white--text',
				},
				{
					value: 'increment_id',
					text: 'Order ID',
					class: 'white--text',
				},
				{
					value: 'item_id',
					text: 'Item ID',
					class: 'white--text',
				},
				{
					value: 'price',
					text: 'Price',
					class: 'white--text',
				},
				{
					value: 'ticket_type',
					text: 'Ticket Type',
					class: 'white--text',
				},
				{
					value: 'event_date',
					text: 'Event date',
					class: 'white--text',
				},
				{
					value: 'product_name',
					text: 'Product Name',
					class: 'white--text',
				},
				{
					value: 'category',
					text: 'Category',
					class: 'white--text',
				},
				{
					value: 'serviceprovider_name',
					text: 'Serviceprovider',
					class: 'white--text',
				},
				{
					value: 'billing_address_company',
					text: 'Company name',
					class: 'white--text',
				},
				{
					value: 'is_rebooked',
					text: 'Rebooked',
					class: 'white--text',
				},
				{
					value: 'b2b_order_comment',
					text: 'Comment',
					class: 'white--text',
				},
			],
			participantHeaderBase: [
				{
					value: 'order_state',
					text: 'Order state',
					class: 'white--text',
				},
				{
					value: 'address',
					text: 'Address',
					class: 'white--text',
				},
				{
					value: 'phoneNumber',
					text: 'Phone Number',
					class: 'white--text',
				},
				{
					value: 'email',
					text: 'Email',
					class: 'white--text',
				},
				{
					value: 'increment_id',
					text: 'Order ID',
					class: 'white--text',
				},
				{
					value: 'item_id',
					text: 'Item ID',
					class: 'white--text',
				},
				{
					value: 'price',
					text: 'Price',
					class: 'white--text',
				},
				{
					value: 'ticket_type',
					text: 'Ticket Type',
					class: 'white--text',
				},
				{
					value: 'event_date',
					text: 'Event date',
					class: 'white--text',
				},
				{
					value: 'product_name',
					text: 'Product Name',
					class: 'white--text',
				},
				{
					value: 'category',
					text: 'Category',
					class: 'white--text',
				},
				{
					value: 'serviceprovider_name',
					text: 'Serviceprovider',
					class: 'white--text',
				},
				{
					value: 'billing_address_company',
					text: 'Company name',
					class: 'white--text',
				},
				{
					value: 'is_rebooked',
					text: 'Rebooked',
					class: 'white--text',
				},
				{
					value: 'b2b_order_comment',
					text: 'Comment',
					class: 'white--text',
				},
			],
			participantData: [],
		}
	},
	methods: {
		expandRow(value) {
			this.expanded.push(value)
			if (this.expanded[0] === this.expanded[1]) {
				this.expanded = []
			} else {
				this.expanded = []
				this.expanded.push(value)
			}
		},
		filterColumns() {
			const currentListOfColumns = this.participantheader.map((el) => el.value)
			// eslint-disable-next-line prefer-const
			for (let col of currentListOfColumns) {
				const elementsInTheCol = this.participantData.map((el) => {
					if (col.indexOf('additionalInfo') !== -1) {
						const additionalKeys = col.split('.')
						// eslint-disable-next-line dot-notation
						return el['additionalInfo'][additionalKeys[1]]
					}
					return el[col]
				}).filter((el) => el !== null && el !== undefined)
				if (elementsInTheCol.length == 0) {
					this.participantheader = this.participantheader.filter((el) => el.value != col)
				}
			}
		},
		addAdditionalInfo() {
			const addInfo = this.participantData.map((el) => el.additionalInfo)
			let newCols = new Set()
			// eslint-disable-next-line prefer-const
			for (let obj of addInfo) {
				// eslint-disable-next-line prefer-const
				for (let key of Object.keys(obj)) {
					newCols.add(key)
				}
			}
			newCols = Array.from(newCols)
			newCols = newCols.map((key) => ({
				value: `additionalInfo.${key}`,
				text: key,
				class: 'white--text',
			}))
			this.participantheader.push(...newCols)
		},
		async getParticipants(a) {
			try {
				this.participantData = []
				this.myloading = true
				// eslint-disable-next-line max-len, no-undef
				const response = await axios.post(`${config.baseAPIurl}/participant-report?installationid=${a.selectedMandators.value}`, {
					date: a.dateFinal,
					selectedBookings: a.selectedBookings,
					selectedProducts: a.selectedProducts,
					selectedResellers: a.selectedResellers,
					selectedSalesChannels: a.selectedSalesChannels,
					selectedServiceproviders: a.selectedServiceproviders,
					selectedSkuGroups: a.selectedSkuGroups,
				})
				this.participantheader = JSON.parse(JSON.stringify(this.participantHeaderBase))
				this.participantData = response.data
				this.addAdditionalInfo()
				this.filterColumns()
			} catch (e) {
				console.log(e)
			} finally {
				this.myloading = false
			}
		},
		async excelExport() {
			const response = await axios({
				// eslint-disable-next-line no-undef
				url: `${config.baseAPIurl}/participant-report/excel`,
				method: 'post',
				responseType: 'blob',
				data: {
					participantHeader: this.participantheader,
					participantData: this.participantData,
				},
				headers: { Authorization: `Bearer ${this.$keycloak.token}` },
			})
			if (this.participantData && this.participantData.length > 0) {
				const filenameExtension = new Date().toISOString()
				// eslint-disable-next-line no-undef
				saveAs(
					new Blob([response.data]),
					`participant_report${filenameExtension}.xlsx`,
				)
			}
		},
	},
	filters: {
		firstLetterCapital(value) {
			if (value) {
				let fullyConcatted = ''
				const splitted = value.split(' ')
				splitted.forEach((name) => {
					fullyConcatted += `${name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()} `
				})
				return fullyConcatted
			}
			return value
		},
	},
}
</script>

<style>
	.participantHeader{
		font-family: Helvetica, sans-serif;
	}

	.v-data-table{
		margin-left: 32px;
		margin-right: 32px;
	}

	.theme--light.v-data-table thead tr:last-child th {
		border-bottom: 1px solid rgba(0, 0, 0, 0.12);
		font-size: 14px;
	}

	th.text-start {
		background-color: grey !important;
		height: 48px;
	}

	.v-data-table tbody td {
		height: 60px;
	}
</style>
